export default __webpack_public_path__ + "static/media/ssgi-agile-leader-cert-badge.81c5a78d.png";